import { render, staticRenderFns } from "./CardStyle5.vue?vue&type=template&id=48d75a2b&scoped=true&"
import script from "./CardStyle5.vue?vue&type=script&lang=js&"
export * from "./CardStyle5.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle5.vue?vue&type=style&index=0&id=48d75a2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d75a2b",
  null
  
)

export default component.exports